import { connect } from "react-redux";
import { getShowAbout } from "../../reducers/ui/selectors";
import { toggleAbout } from "../../reducers/ui/actions";

import About from "./About";

const mapStateToProps = state => ({
  show: getShowAbout(state)
});

const mapDispatchToProps = dispatch => ({
  hideAbout: () => dispatch(toggleAbout(false))
});

export default connect(mapStateToProps, mapDispatchToProps)(About);



// WEBPACK FOOTER //
// ./src/components/About/AboutContainer.js